export default __webpack_public_path__ + "static/media/ENTREVISTA-NELSON.ba1582a1.png";